<template>
  <div>
    <b-button
      class="interval-player-button"
      type="is-primary"
      @click="play"
      expanded
    >
      <p class="heading">{{ text }}</p>
      <p><b-icon pack="fas" :icon="iconName"></b-icon></p>
    </b-button>
  </div>
</template>

<script>
export default {
  props: ["src", "from", "to", "text", "playIcon"],
  data() {
    return {
      playing: false,
      audio: new Audio(this.src),
      intervalId: 0
    };
  },
  computed: {
    iconName() {
      return this.playing ? "stop" : this.playIcon ? this.playIcon : "play";
    }
  },
  methods: {
    play() {
      if (this.playing) {
        this.pause();
        return;
      }
      this.audio.currentTime = this.from;
      this.playing = true;
      this.audio.play();
      this.startInterval();
    },
    pause() {
      this.playing = false;
      this.audio.pause();
      this.stopInterval();
      this.$emit("currentTime", this.from);
    },
    startInterval() {
      this.intervalId = setInterval(() => {
        const t = this.audio.currentTime;
        const maxTime = this.to ? this.to : this.audio.duration;
        this.$emit("currentTime", t);
        if (t >= maxTime || this.audio.ended) this.pause();
      }, 50);
    },
    stopInterval() {
      clearInterval(this.intervalId);
    }
  },
  beforeDestroy() {
    this.playing = false;
    this.audio.pause();
    this.stopInterval();
  }
};
</script>

<style lang="scss" scoped>
.interval-player-button {
  height: 100%;
  width: 100%;
}
</style>
